@if (visible) {
  <div [style.height.px]="size" [style.width.px]="size" class="spinner"></div>
}
